export const HIDE_OPERATION = {
	type: 'hide',
	enabled: false,
	title: 'Hide products',
	buttonText: 'Hide products',
	successMessage: 'products hidden',
	analyticsAction: 'Submit barcode'
};

export const UNHIDE_OPERATION = {
	type: 'unhide',
	enabled: true,
	title: 'Unhide products',
	buttonText: 'Unhide products',
	successMessage: 'products unhidden',
	analyticsAction: 'Submit barcode'
};
